import { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export const BACK_URL_PARAM_KEY = 'backUrl';

export function getBackUrlFromLocation(
  location: Location = window.location,
  defaultUrl: string = '/'
): string {
  const searchParams = new URLSearchParams(location.search);
  const backUrl = searchParams.get(BACK_URL_PARAM_KEY);
  return backUrl ? decodeURIComponent(backUrl) : defaultUrl;
}

function useBackUrl() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const createBackUrl = useCallback((): string => {
    const url = location.pathname + location.search;
    return encodeURIComponent(url);
  }, [location.pathname, location.search]);

  const getBackUrl = useCallback((): string | null => {
    const backUrl = searchParams.get(BACK_URL_PARAM_KEY);
    return backUrl ? decodeURIComponent(backUrl) : null;
  }, [searchParams]);

  return {
    createBackUrl,
    getBackUrl
  };
}

export default useBackUrl;
